/**
 * Mode and URL Utilities
 * Pure functions for handling mode detection and URL parameter parsing
 */

import type { Dispatch } from '@reduxjs/toolkit';

import { UI_MODES, URL_PARAM_VALUES, URL_PARAMS } from '../constants/steps';
import type { CopilotState } from '../data-layer/types';
import { setMode } from '../data-store/copilotSlice';

/**
 * Check if the current mode is edit mode
 */
export const isEditMode = (getState: () => unknown): boolean => {
  const state = getState() as { copilot?: CopilotState };

  return state.copilot?.ui.mode === UI_MODES.EDIT;
};

/**
 * Parse URL parameters and set the appropriate mode
 */
export const parseUrlParameters = (dispatch: Dispatch): void => {
  const urlParams = new URLSearchParams(window.location.search);
  const endpointKey = urlParams.get(URL_PARAMS.ENDPOINT_KEY);
  const isEditModeFromUrl =
    urlParams.get(URL_PARAMS.IS_EDIT) === URL_PARAM_VALUES.TRUE &&
    !!endpointKey;

  dispatch(
    setMode({
      mode: isEditModeFromUrl ? UI_MODES.EDIT : UI_MODES.CREATE,
      endpointKey,
    })
  );
};
